const { io } = require("socket.io-client");

const socket = io("https://api.kakaking.in", { transports: ["websocket"] });


socket.on("connect_error", () => {
        socket.io.opts.transports = ["polling", "websocket"];
      });
export default socket;